var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('router-view'),_c('Breadcrumb',{attrs:{"items":_vm.breadcrumbs}}),_c('Invoice',{attrs:{"invoiceId":_vm.invoiceId,"userId":_vm.$store.getters.getUser.id,"scope":"user"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }